import React from 'react';
import MyCommentBox from "./MyCommentBox";

const MyCommentsProfile = () => {
    return (
        <div className="my-comments-profile-wrapper">
            <div className="comment-parent">
            <MyCommentBox/>
            </div>
            <div className="comment-parent">
                <MyCommentBox/>
            </div>
            <div className="comment-parent">
                <MyCommentBox/>
            </div>
            <div className="comment-parent">
                <MyCommentBox/>
            </div>
            <div className="comment-parent">
                <MyCommentBox/>
            </div>
        </div>
    );
};

export default MyCommentsProfile;
